<template>
  <div class="sky_wrap">
    <div class="sky_img">
      <div class="img_tit hidden-xs-only">
        智能充电技术驱动新能源未来
      </div>
      <div class="img_desc hidden-xs-only">
        聚焦智能充电技术创新，构建高效、安全的充电网络，推动新能源产业高质量发展，驱动未来绿色出行新生态。
      </div>
      <!-- <div
        class="img_btn"
        @click="handleToDemo"
      >立即体验</div> -->
    </div>

    <div class="two_level">
      <div class="two_level_wrap">
        <div class="two_left">
          <div class="tit">新能源充电技术发展导向</div>
          <div
            v-for="item in twoLevelArr"
            :key="item.id"
            class="left_list"
          >
            <div class="list_item">
              <span>{{ item.id }}</span>{{ item.txt }}
            </div>
          </div>
        </div>
        <div class="two_right">
          <img
            alt=""
            src="@/assets/img/0146137d.png"
          />
        </div>
      </div>
    </div>
    <div class="sky_title_wrap">
      <div class="sky_inner">
        <div class="inner_left">
          <img
            alt=""
            src="../../assets/img/tupianright.png"
          />
        </div>
        <div class="inner_center">
          <div class="sky_title">新技术发展</div>
          <div class="sky_desc">
            成功研发40KW、60KW液冷模块，满足了以新能源电动汽车为代表的各种新兴能源对市场的快速充电需求
          </div>
        </div>
        <div class="inner_right">
          <img
            alt=""
            src="../../assets/img/tupianleft.png"
          />
        </div>
      </div>
    </div>

    <div class="sky_card">
      <ChargeModule :skyList="chargeList" />
    </div>
    <div class="sky_title_wrap">
      <div class="sky_inner">
        <div class="inner_left">
          <img
            alt=""
            src="../../assets/img/tupianright.png"
          />
        </div>
        <div class="inner_center">
          <div class="sky_title">成熟的充电运营平台</div>
          <div class="sky_desc">
            成熟充电运营平台，高效稳定，赋能智慧出行。
          </div>
        </div>
        <div class="inner_right">
          <img
            alt=""
            src="../../assets/img/tupianleft.png"
          />
        </div>
      </div>
    </div>

    <div class="sky_card">
      <SkyCard :skyList="skyList" />
    </div>

    <div class="three_level">
      <!-- <div class="three_content">
        <p>45+新能源，智能化的招商预测模型</p>
        <p>快速形成专属于您园区的精准画像</p>
        <p>输出动态更新的目标客户名单</p>
        <el-button class="three_btn" plain round @click="handleToDemo">申请免费体验</el-button>
      </div> -->
    </div>

    <div class="sky_title_wrap">
      <div class="sky_inner">
        <div class="inner_left">
          <img
            alt=""
            src="../../assets/img/tupianright.png"
          />
        </div>
        <div class="inner_center">
          <div class="sky_title">探索智能充电新领域</div>
          <div class="sky_desc">
            有效触达超过2万家新能源与智能充电领域企业，为园区提供精准招商线索，提升园区品牌影响力与产业集聚效应。
          </div>
        </div>
        <div class="inner_right">
          <img
            alt=""
            src="../../assets/img/tupianleft.png"
          />
        </div>
      </div>
    </div>

    <div class="four_level">
      <div class="four_img hidden-xs-only">
        <img
          alt=""
          src="@/assets/img/home/图片2.png"
        />
        <img
          alt=""
          src="@/assets/ptyy.png"
        />
      </div>

    </div>

    <div class="four_level_mobile hidden-sm-and-up">
      <img
        alt=""
        src="../../assets/img/12d29ab7b6.png"
      />
      <el-button class="four_mobile_btn">申请免费体验</el-button>
    </div>

    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import SkyCard from './SkyCard.vue'
import ChargeModule from './ChargeModule.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  data () {
    return {
      twoLevelArr: [
        {
          id: '01',
          txt: '超快充技术,实现“充电如加油”的体验',
        },
        {
          id: '02',
          txt: '通过电磁感应或磁共振技术，实现无需插拔的便捷充电',
        },
        {
          id: '03',
          txt: '电动汽车与电网双向能量交换，平衡电网负荷，提升能源利用效率',
        },
        {
          id: '04',
          txt: '基于大数据和AI算法，优化充电调度与能源分配',
        },
      ],
      skyList: [
        {
          tit: '智能充电管理平台',
        },
        {
          tit: '智能充电监控运营平台',
        },
        {
          tit: '智能充电小程序',
        },
      ],
      chargeList: [
        {
          tit: '40KW-风冷充电模块',
        },
        {
          tit: '60KW-液冷充电模块',
        },
        {
          tit: '低速两轮分布式充电桩',
        },
        {
          tit: '高速两轮集中式充电桩',
        },
        {
          tit: '直流集群充电堆',
        },
        {
          tit: '大功率液冷超充系统',
        },
      ],
    }
  },
  methods: {
    handleToDemo () {
      this.$router.push('/demo')
    }
  },
  components: {
    ChargeModule,
    SkyCard,
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.sky_wrap {
  .sky_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/img/banner22.png") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .two_level {
    width: 100%;
    background: #f4f9fc;
    padding: 50px 0;
    padding-top: 100px;

    .two_level_wrap {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 768px) {
        flex-direction: column;
        width: 90%;
      }

      .two_left {
        flex: 1;
        display: flex;
        flex-direction: column;

        .tit {
          color: #2091d3;
          font-size: 30px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1.2rem;
          }
        }

        .left_list {
          margin-top: 30px;

          &:nth-child(2) {
            margin-top: 50px;
          }

          .list_item {
            color: #666;
            width: 100%;
            height: 70px;
            display: flex;
            align-items: center;
            background: url("../../assets/img/bg123.png") -20px 0 no-repeat;
            background-size: 100% 100%;
            font-size: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            @media screen and (max-width: 768px) {
              font-size: 0.8rem;
              height: 70px;
              white-space: pre-wrap;
              padding: 0 10px;
            }

            span {
              color: #2091d3;
              font-size: 24px;
              padding: 0 10px;
              @media screen and (max-width: 768px) {
                font-size: 1.2rem;
              }
            }
          }
        }
      }

      .two_right {
        flex: 1;
        margin-left: 60px;
        display: flex;
        align-items: center;

        img {
          width: 90%;
        }
      }
    }
  }

  .sky_title_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .sky_inner {
      display: flex;
      justify-content: center;

      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }

      .inner_center {
        width: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;
        @media screen and (max-width: 768px) {
          flex: 2.2;
        }

        .sky_title {
          font-size: 40px;
          font-weight: bold;
          font-size: 30px;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .sky_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }

      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }
    }
  }

  .sky_card {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  .three_level {
    width: 100%;
    height: 540px;
    background: url("../../assets/img/bg_cy.png") 0 0 no-repeat;
    position: relative;
    left: 50px;

    .three_content {
      position: absolute;
      left: 10%;
      top: 50%;
      transform: translateY(-50%);
      color: #191919;

      p {
        font-size: 20px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }

      .three_btn {
        background: transparent;
        color: #fff;

        &:hover {
          color: #2091d3;
        }
      }
    }
  }

  .four_level {
    width: 70%;
    margin: 50px auto;
    display: flex;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 90%;
      padding: 30px 0 50px 0;
    }

    .four_img {
      display: flex;
      width: 60%;

      img {
        width: 80%;
        margin-right: 20px;
      }
    }

    .four_right {
      width: 40%;
      height: 400px;
      padding: 80px 30px;
      margin-left: -10px;
      background: #f4f9fc;
      @media screen and (max-width: 768px) {
        width: 100%;
        background: #fff;
      }

      .four_tit {
        font-size: 20px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 1.4rem;
        }
      }

      .four_zhengfangxing {
        width: 10%;
        padding: 10px 0;

        img {
          width: 100%;
        }
      }

      .four_desc {
        color: #5b6e74;
        font-size: 15px;
        margin-top: 20px;
        line-height: 22px;
        @media screen and (max-width: 768px) {
          font-size: 0.8rem;
        }
      }

      .four_btn {
        background: #feb65c;
        color: #fff;
        border-radius: 20px;
        margin-top: 50px;
        @media screen and (max-width: 768px) {
          width: 90px;
          height: 35px;
          border-radius: 20px;
          margin-top: 20px;
          font-size: 14px;
        }
      }
    }
  }

  .four_level_mobile {
    width: 100%;
    position: relative;
    @media screen and (max-width: 768px) {
      margin-top: 100px;
    }

    .four_mobile_btn {
      border-radius: 20px;
      width: 120px;
      height: 40px;
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      background: transparent;
      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }

    img {
      width: 100%;
    }
  }

  .sky_shows_wrap {
    width: 100%;
    background: url("../../assets/img/witness-bgc369221.png") 0 0 no-repeat;
    background-size: cover;
    padding: 10px 0 50px 0;
    margin-top: 100px;
    box-sizing: border-box;

    .sky_shows_imgs {
      display: flex;
      justify-content: center;
      margin-top: 50px;

      img {
        @media screen and (max-width: 768px) {
          width: 90%;
          margin: 10px;
        }
      }
    }
  }
}
</style>
